module.exports = __webpack_public_path__ + "img/1701389083373-2ada28f2-9d6c-4161-bfb2-caf60d653e09.jpeg.bfcabaf9.webp";